import { InjectionToken } from '@angular/core';

export const INTERNAL_STATUS = new InjectionToken<InternalStatus>('INTERNAL_STATUS');

export interface InternalStatus {
  code: number;
  message?: string;
}
